import React, { useState, useEffect } from 'react'
import Loading from '../../Commons/Loading/Loading';
import FooterFormulario from '../../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import '../DivisionesDetalles.scss'
import DivisionBanner from '../../DivisionContainer/DivisionBanner/DivisionBanner';
import { Modal } from 'react-bootstrap'


const PisosTanques = () => {


    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };

    const handleShow = (paramUrl, paramDesc) => {

        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)

        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    })

    if (loading) { return <Loading /> }

    return (

        <section className='container-fluid p-0 containerBlock' >


            <Modal
                show={show}
                size='lg'
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Obra de Fundaciones de tanque.</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
                </Modal.Body>

                <Modal.Footer>
                    <small >{txtDes}</small>
                </Modal.Footer>
            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-reparacion-de-tanques.jpg"
                    alt="Reparacion de Tanques."
                    loading='lazy'
                    className='divisionItem__container--img'
                />

                <div className='divisionItem__container--textos' >
                    <h3 className='divisionItem__container--header'>DIVISION</h3>
                    <h1 className='divisionItem__container--title'>OBRAS CIVILES INDUSTRIALES</h1>

                </div>

            </div>

            <div className='container-fluid divisionItem__detail'>
                <div className='container animated fast fadeIn'>
                    <Link to={'/obras-civiles-industriales/'}>
                        <small>
                            <i className="fas fa-angle-double-left" style={{ 'paddingBottom': '15px', 'paddingRight': '10px' }} ></i>
                            Volver a Division</small>
                    </Link>

                    <div className='row'>
                        <div className='col-md-6'>

                            <img
                                src="../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-01.jpg"
                                alt="Tanque de 50.000m3. con la obra terminada."
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            />

                        </div>

                        <div className='col-md-6 divisionItem__detail--block'>
                            <h1 className='divisionItem__detail--title' >Fundaciones de tanque</h1>
                            <p className='divisionItem__detail--text' >
                                Construimos plateas y anillos perimetrales de hormigón armado como fundación de tanques. La misma se realiza en cumplimiento de normas nacionales <strong>"CIRSOC 201"</strong> y bajo de lineamientos de la norma <strong>"API 650"</strong>.<br /><br /> Su diseño y cálculo se adaptan al diámetro y la altura de cada tanque, al producto almacenado y al estudio de suelo. En obra se hacen los controles de calidad del hormigón: asentamiento, toma de probetas y curado según la época del año.<br /><br />

                                En tanques en servicio evaluamos y reparamos los anillos existentes según <strong>"API 653"</strong>: fisuras, desprendimientos, armaduras expuestas y asentamientos de borde. También hacemos las mediciones de asentamiento necesarias para planificar la reparación.
                            </p>

                        </div>

                    </div>

                    <div className='gallery__cont'>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-01.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-01.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-03.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-03.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-02.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-02.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-04.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-04.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-05.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-05.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-06.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-06.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-07.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-07.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-08.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-08.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-09.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-09.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-10.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-10.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-11.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-11.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-12.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-12.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-13.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-13.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-14.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-14.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-15.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-15.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-16.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-16.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-17.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-17.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                            <img onClick={() => handleShow('../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-18.jpg', 'Obras de Fundaciones de tanque')} src='../images/divisiones/obras-civiles-industriales/pisos-de-tanques/obra-piso-18.jpg' alt='Obra de Fundaciones de tanque.' loading='lazy' />
                        </div>

                    </div>
                </div>
            </div>
            <div>

                <h3 className='divisionItem__bajada--tit text-center'>
                    Otras Divisiones
                </h3>

                <div className='row divisionItem__proyectosDestacados p-0'>
                    <DivisionBanner
                        division={'Piso: Reparación y Construcción'}
                        imgUrl={'../images/divisiones/division-banners/divisionBanners-piso-reparacion.jpg'}
                        linkUrl={'/obras-civiles-industriales/piso-teparación-y-construccion/'}
                    />
                    <DivisionBanner
                        division={'Techo: Reparación y Construcción'}
                        imgUrl={'../images/divisiones/division-banners/divisionBanners-techo-reparacion.jpg'}
                        linkUrl={'/obras-civiles-industriales/techo-reparacion-y-construccion/'}
                    />
                    <DivisionBanner
                        division={'Still Pipe '}
                        imgUrl={'../images/divisiones/division-banners/divisionBanners-still-pipe.jpg'}
                        linkUrl={'/obras-civiles-industriales/still-pipe/'}
                    />
                    <DivisionBanner
                        division={'P.E.A.D'}
                        imgUrl={'../images/divisiones/division-banners/divisionBanners-pead.jpg'}
                        linkUrl={'/obras-civiles-industriales/pead/'}
                    />
                </div>

            </div>

            <FooterFormulario className='mt-5' />

        </section>
    )
}

export default PisosTanques